import Button from "react-bootstrap/Button";
import SpinnerButton from "../../../components/SpinnerButton";
import SimpleModal from "../../../components/ModalComponents/SimpleModal";
import React, {useState} from "react";
import {useDownloadDocumentAsPdf, useOpenDocumentPdf} from "../../../api/DocumentApi";
import Row from "react-bootstrap/esm/Row";
import CustomSelect from "../../../components/FormComponents/CustomSelect";
import Col from "react-bootstrap/esm/Col";

interface IOpenDownloadAsPDF {
    showPdfModal: boolean;
    closePdfModal: () => void;
    pdfVariant: 'OPEN' | 'DOWNLOAD';

}

const OpenDownloadAsPDF = (
    {
        showPdfModal,
        pdfVariant,
        closePdfModal,
    }: IOpenDownloadAsPDF) => {
    const [orientation, setOrientation] = useState<'landscape' | 'portrait'>("landscape");
    const [download, isDownloadingPdf] = useDownloadDocumentAsPdf(orientation);
    const [openPdf, isOpeningPdf] = useOpenDocumentPdf(orientation);

    const handleOpenDownloadPdf = () => {
        pdfVariant === 'OPEN' ? openPdf(orientation) : download(orientation);
        closePdfModal();
    }

    const handleCloseModal = () => {
        closePdfModal();
    }

    const renderBody = () => (<>
        <Row>
            <Col>Orientering:</Col>
        </Row>
        <Row>
            <Col>
                <CustomSelect
                    isEditMode={true}
                    name={"orientation"}
                    value={orientation}
                    onChange={(e: any) => setOrientation(e.target.value ?? '')}
                    options={<>
                        <option key={'landscape'} value={'landscape'}>Liggande</option>
                        <option key={'portrait'} value={'portrait'}>Stående</option>
                    </>}
                >
                </CustomSelect>
            </Col>
        </Row>
    </>)

    const renderFooter = () => (<>
        <Button variant="secondary" onClick={handleCloseModal}>Avbryt</Button>
        <SpinnerButton
            text={pdfVariant === 'OPEN' ? "Öppna" : "Ladda ner"}
            isLoading={isDownloadingPdf || isOpeningPdf}
            disabled={false}
            onClick={handleOpenDownloadPdf}
        />
    </>)

    return <SimpleModal
        show={showPdfModal}
        size={"sm"}
        header={pdfVariant === 'OPEN' ? <span>Öppna PDF</span> : <span>Ladda ner PDF</span>}
        body={renderBody()}
        footer={renderFooter()}
    />
};

export default OpenDownloadAsPDF;